module.exports = __webpack_public_path__ + "static/media/haachim_thumb.91e1814e.jpg";